import React from "react";
import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import ArrowCircleRightIcon from "@mui/icons-material/ArrowCircleRight";
import { getDistance } from "../../../../utils/calcHelpers";

export default function LoadProfileRouteInfoLineup({ stops }) {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        margin: "20px",
        position: "relative"
      }}>
      <Box
        sx={{
          position: "absolute",
          top: "5px",
          bottom: 0,
          left: "20%",
          width: "6px",
          backgroundColor: "black_opacity.20"
        }}
      />
      {stops.map((stop, i) => {
        let nextStop = stops[i + 1];
        return (
          <Box key={`lineup-${stop.id}`}>
            {i === 0 ?
              <>
                <ArrowCircleRightIcon sx={{ color: "primary.main", fontSize: "20px", position: "relative" }} />
                <Box sx={{
                  transform: "rotate(-45deg)",
                  backgroundColor: "white_opacity.100",
                  borderRadius: "4px",
                  border: "1px solid",
                  borderColor: "black_opacity.40",
                  top: "250%",
                  position: "relative",
                  padding: "2px 4px"
                }}>
                  <Typography variant="body2" color="black_opacity.80">
                    {getDistance(stop.latitude, stop.longitude, nextStop.latitude, nextStop.longitude)}mi
                  </Typography>
                </Box>
              </>
              :
              <>
                <Box
                  sx={{
                    width: "18px",
                    height: "18px",
                    backgroundColor: "white_opacity.100",
                    borderRadius: "100px",
                    border: "1px solid",
                    borderColor: "black_opacity.40",
                    position: "relative"
                  }}>
                </Box>
                {i < stops.length - 1 &&
                  <Box sx={{
                    transform: "rotate(-45deg)",
                    backgroundColor: "white_opacity.100",
                    borderRadius: "4px",
                    border: "1px solid",
                    borderColor: "black_opacity.40",
                    position: "relative",
                    top: "250%",
                    padding: "2px 4px"
                  }}>
                    <Typography variant="body2" color="black_opacity.80">
                      {getDistance(stop.latitude, stop.longitude, nextStop.latitude, nextStop.longitude)}mi
                    </Typography>
                  </Box>
                }
              </>
            }
          </Box>
        );
      })}
    </Box>
  );
}

LoadProfileRouteInfoLineup.propTypes = {
  stops: PropTypes.array.isRequired
};